"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userFeedErrorSelector = exports.userFeedhasNextSelector = exports.userFeedNextSelector = exports.userFeedDataSelector = exports.userFeedSelector = exports.userFeedStateSelector = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userFeedStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.feed;
});
exports.userFeedStateSelector = userFeedStateSelector;
var userFeedSelector = (0, _reselect.createSelector)(userFeedStateSelector, function (feed) {
  return feed.userFeed;
});
exports.userFeedSelector = userFeedSelector;
var userFeedDataSelector = (0, _reselect.createSelector)(userFeedSelector, function (userFeed) {
  return userFeed ? userFeed.data : null;
});
exports.userFeedDataSelector = userFeedDataSelector;
var userFeedMetaSelector = (0, _reselect.createSelector)(userFeedSelector, function (userFeed) {
  return userFeed ? userFeed.meta : null;
});
var userFeedNextSelector = (0, _reselect.createSelector)(userFeedMetaSelector, function (userFeedMeta) {
  return userFeedMeta ? userFeedMeta.next : null;
});
exports.userFeedNextSelector = userFeedNextSelector;
var userFeedhasNextSelector = (0, _reselect.createSelector)(userFeedMetaSelector, function (userFeedMeta) {
  return userFeedMeta ? userFeedMeta.hasNext : null;
});
exports.userFeedhasNextSelector = userFeedhasNextSelector;
var userFeedErrorSelector = (0, _reselect.createSelector)(userFeedStateSelector, function (feed) {
  return feed.error;
});
exports.userFeedErrorSelector = userFeedErrorSelector;
var _default = {
  userFeedDataSelector: userFeedDataSelector,
  userFeedMetaSelector: userFeedMetaSelector,
  userFeedNextSelector: userFeedNextSelector,
  userFeedhasNextSelector: userFeedhasNextSelector,
  userFeedErrorSelector: userFeedErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map